jQuery(document).ready(function ($) {

    /* Update special pruduct price */
    $(document).on('input', '.postid-315214 .wc-pao-addon-custom-price', function () {
        var price = parseFloat($('.postid-315214 .wc-pao-addon-pris .wc-pao-addon-custom-price').val());
        if (isNaN(price)) {
            price = 0;
        }
        var freight = parseFloat($('.postid-315214 .wc-pao-addon-fraktpris .wc-pao-addon-custom-price').val());
        if (isNaN(freight)) {
            freight = 0;
        }
        var total = price + freight;
        var total_price = $('.product-price bdi');
        total_price.text(total + ' kr');
    });

    /* MOVE ADDONS BOXES BEFORE ADD TO CART */
    $(".variations_form").on("show_variation", function () {
        $(".wc-pao-addon-container").prependTo(".single_variation_wrap");

        ShouldDisplayPrice();

        if ($('.woocommerce-variation-price').html() == '') {
            $('.entry-summary .price').show();
        }
    });

    //$("#product-addons-total").prependTo(".single_variation");

    var $cart = $('body').find('.cart:not(.cart_group)');
    if ($cart.length > 0) {
        $cart.on('updated_addons', ShouldDisplayPrice)
    }

    function ShouldDisplayPrice() {
        var $price_parent = $('.wc-pao-subtotal-line .price .amount');
        var $product_price = $('.product-page-price .amount');
        var $product_variation_price = $('.woocommerce-variation-price .amount');

        if ($price_parent.length > 0) {
            var price = FixPrice($price_parent.html());
            var product_price = FixPrice($product_price.html());
            var product_variation_price = FixPrice($product_variation_price.html());

            if (price === product_price || price === product_variation_price) {
                $('.product-addon-totals').hide();
            } else {
                $('.product-addon-totals').show();
            }
        }
    }

    function FixPrice(price) {
        if (price) {
            price = price.replace(/\s/, "");
            return parseInt(price);
        }

        return false;
    }

});
